import React, { useState, useEffect } from "react";
import { noImg } from "vrcore-dashboard/dist/utilities";
import {
    Grid,
    Checkbox,
    IconButton,
    Tooltip,
    Button,
    TablePagination,
    TextField,
    Select,
    MenuItem,
    withStyles,
    List,
    ListItem,
    Typography,
} from "@material-ui/core";
import { Clear as ClearIcon } from "@material-ui/icons";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";
import TableList from "../../../Utilities/Helpers/TableList/TableList";
import config from "./tableConfig";
import {
    Settings as OptionIcon,
    CheckCircle as ArchiveIcon,
    ReportProblem as ReportIcon,
} from "@material-ui/icons";
import { StyledContent, StyledHeader } from "../../../styles";
const QRCode = require("qrcode.react");
const CustomCheckbox = withStyles({
    root: {
        color: "#0188cc",
        "&$checked": {
            color: "#0188cc",
        },
        "&$disabled": {
            color: "#ddd",
        },
    },
    checked: {},
    disabled: {},
})((props) => <Checkbox color="default" {...props} />);

export default (props) => {
    const [qrs, setQrs] = useState(props.qrs);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedPhotoModal, setSelectedPhotoModal] = useState(false);
    const [generatorModal, setGeneratorModal] = useState(false);
    const [selectedPhoto, setSelectedPhoto] = useState(false);
    const [categoryModal, setCategoryModal] = useState(false);
    const [newCategory, setNewCategory] = useState("");
    const [warningModal, setWarningModal] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    useEffect(() => {
        setQrs(props.qrs);
    }, [props.qrs]);
    useEffect(() => {
        setQrs(props.qrs);
    }, [props.qrs]);
    return (
        <>
            <div>
                <Grid container spacing={2}>
                    <Grid xs={6}>
                        <TablePagination
                            colSpan={6}
                            ActionsComponent={TablePaginationHelper}
                            count={qrs.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={(event, page) => setPage(page)}
                            rowsPerPageOptions={[50, 100]}
                            onChangeRowsPerPage={(event) =>
                                setRowsPerPage(event.target.value)
                            }
                        />
                    </Grid>
                    <Grid xs={6}>
                        <TextField
                            label="Search By Name"
                            value={
                                props.equFilter === false ? "" : props.equFilter
                            }
                            onChange={(event) => {
                                props.setEquFilter(event.target.value);
                            }}
                        />
                        <IconButton>
                            <ClearIcon
                                onClick={() => props.setEquFilter(false)}
                            />
                        </IconButton>
                        <Select
                            value={props.equType}
                            onChange={(event) =>
                                props.setEquipmentType(event.target.value)
                            }
                        >
                            <MenuItem value="all_categories">
                                All Categories
                            </MenuItem>

                            {props.equipmentTypes &&
                                props.equipmentTypes.map((e) => {
                                    return <MenuItem value={e}>{e}</MenuItem>;
                                })}
                        </Select>
                        &nbsp; &nbsp;
                        <Button
                            style={{ background: "#0188cc" }}
                            onClick={() => {
                                setCategoryModal(true);
                            }}
                        >
                            <Typography
                                style={{
                                    color: "white",
                                }}
                            >
                                Add Category
                            </Typography>
                        </Button>
                        &nbsp; &nbsp;
                        <Button
                            style={{ background: "#0188cc" }}
                            onClick={() => {
                                setGeneratorModal(true);
                            }}
                        >
                            <Typography
                                style={{
                                    color: "white",
                                }}
                            >
                                QR Code Generator
                            </Typography>
                        </Button>
                        <Tooltip title="Change Categories of Selected Items">
                            <IconButton
                                aria-haspopup="true"
                                disabled={
                                    selectedFiles.length === 0 ? true : false
                                }
                                onClick={() => {
                                    props.setChangeCatagoryModal(selectedFiles);
                                }}
                                style={{ float: "right" }}
                            >
                                <OptionIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>

                <TableList
                    listData={qrs.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                    )}
                    tableConfig={config}
                    permissions={{
                        read: true,
                        update: props.canUpdate,
                        delete: props.canDelete,
                    }}
                    enableSorting={false}
                    isReports={false}
                    viewAction={(data) => {
                        console.log(data);
                        props.setViewModal(data.uid, data);
                    }}
                    editAction={(data) => {
                        props.setAddEditModal("edit", data, data.uid);
                    }}
                    deleteAction={(data) => {
                        props.setRemoveModal(data.uid, data);
                    }}
                    showEditAction={true}
                    customCellKeys={["selected", "profile.status"]}
                    customCells={(data, cellKey) => {
                        if (cellKey === "selected") {
                            return (
                                <CustomCheckbox
                                    checked={selectedFiles.includes(data.uid)}
                                    value={data.uid}
                                    onClick={() => {
                                        if (selectedFiles.includes(data.uid)) {
                                            setSelectedFiles(
                                                selectedFiles.filter(
                                                    (e) => data.uid !== e
                                                )
                                            );
                                        } else {
                                            setSelectedFiles([
                                                ...selectedFiles,
                                                data.uid,
                                            ]);
                                        }
                                    }}
                                />
                            );
                        } else if (cellKey === "profile.status") {
                            return (
                                <>
                                    {checkOperational(data.profile.status)}
                                    &nbsp; {data.profile.status}
                                </>
                            );
                        }
                    }}
                />
            </div>
            <Modal isOpen={categoryModal}>
                {/* <ModalHeader>Add New User Type</ModalHeader> */}
                <StyledHeader>
                    <Typography variant="headline" background="">
                        Add New Category
                    </Typography>
                </StyledHeader>
                <StyledContent>
                    <ModalBody>
                        <TextField
                            helperText="Category name should not include special character /"
                            value={newCategory}
                            label={"Category Name"}
                            onChange={(event) => {
                                if (
                                    props.tempTitles.includes(
                                        event.target.value
                                    ) === true
                                ) {
                                    setWarningModal(true);
                                }
                                setNewCategory(event.target.value);
                            }}
                        />
                        <Typography variant="h6" style={{ marginTop: 24 }}>
                            Registered Categories
                        </Typography>
                        <List style={{ width: "100%" }}>
                            {props.categories &&
                                Object.values(props.categories).map((e) => {
                                    return (
                                        <ListItem
                                            style={{
                                                margin: 4,
                                                borderLeft: "2px solid #ddd",
                                                width: "100%",
                                            }}
                                        >
                                            {e}
                                        </ListItem>
                                    );
                                })}
                        </List>
                    </ModalBody>
                </StyledContent>
                <ModalFooter>
                    <Button
                        onClick={() => {
                            setCategoryModal(false);
                            setNewCategory("");
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={
                            newCategory === "" ||
                            newCategory.includes("/") === true
                        }
                        onClick={() => {
                            props.submitNewCategory(newCategory);
                            setCategoryModal(false);
                            setNewCategory("");
                        }}
                        variant="contained"
                        color="primary"
                        style={{
                            background:
                                newCategory.includes("/") === true
                                    ? "grey"
                                    : "#0188cc",
                            color: "white",
                        }}
                    >
                        Submit
                    </Button>
                </ModalFooter>
            </Modal>
            {/* ------------------------------Warning Modal--------------------------- */}
            <Modal isOpen={warningModal}>
                <ModalHeader style={{ color: "red" }}>Warning!!!</ModalHeader>
                <ModalBody>
                    <b>Category name already exists</b>
                </ModalBody>
                <ModalFooter>
                    <Button
                        onClick={() => {
                            setWarningModal(false);
                            setNewCategory("");
                        }}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={selectedPhotoModal}>
                <ModalHeader>View Image</ModalHeader>

                <ModalBody>
                    <img
                        src={selectedPhoto !== "" ? selectedPhoto : noImg}
                        alt={"imageprofile"}
                        style={{
                            width: "100%",
                            height: "auto",
                        }}
                    />
                </ModalBody>

                <ModalFooter>
                    <div>
                        <Button
                            onClick={() => {
                                setSelectedPhoto(false);
                                setSelectedPhotoModal(false);
                            }}
                        >
                            Close
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
            <Modal isOpen={generatorModal}>
                <ModalHeader>Equipment QR Code</ModalHeader>
                <ModalBody>
                    <List style={{ width: "100%" }}>
                        {qrs &&
                            qrs.map((equData) => {
                                return (
                                    <ListItem
                                        style={{
                                            margin: 4,
                                            borderLeft: "2px solid #ddd",
                                            width: "100%",
                                        }}
                                    >
                                        <Grid container spacing={3}>
                                            <Grid
                                                style={{
                                                    textAlign: "center",
                                                    justifyContent: "center",
                                                    alignContent: "center",
                                                    display: "grid",
                                                }}
                                                item
                                                xs={6}
                                            >
                                                {equData.name}
                                            </Grid>

                                            <QRCode
                                                id="QRCODE"
                                                bgColor="#FFFFFF"
                                                fgColor="#000000"
                                                level="Q"
                                                style={{
                                                    width: 100,
                                                    height: 100,
                                                }}
                                                includeMargin={true}
                                                size={512}
                                                imageSettings={{
                                                    height: 500,
                                                    width: 500,
                                                }}
                                                value={equData.uid}
                                                renderAs="canvas"
                                                hidden={true}
                                            />

                                            <Grid
                                                style={{
                                                    textAlign: "center",
                                                    justifyContent: "center",
                                                    alignContent: "center",
                                                    display: "grid",
                                                }}
                                                item
                                                xs={6}
                                            >
                                                <Button
                                                    style={{
                                                        background: "#0188cc",
                                                        color:"white"
                                                    }}
                                                    onClick={() => {
                                                        var canvas = document.getElementById(
                                                            "QRCODE"
                                                        );
                                                        props.setQRData(
                                                            equData.uid,
                                                            equData,
                                                            canvas.toDataURL()
                                                        );
                                                        setGeneratorModal(
                                                            false
                                                        );
                                                    }}
                                                >
                                                    Generate QR Code
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </ListItem>
                                );
                            })}
                    </List>
                </ModalBody>
                <ModalFooter>
                    <div>
                        <Button
                            onClick={() => {
                                setGeneratorModal(false);
                            }}
                        >
                            Close
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};
const checkOperational = (status) => {
    if (status === "Operational" || status === "operational") {
        return <ArchiveIcon style={{ color: "green" }} />;
    } else if (
        status === "Commissioning" ||
        status === "Needing Repair" ||
        status === "Needing Service"
    ) {
        return <ReportIcon style={{ color: "red" }} />;
    } else {
        return "";
    }
};
